import { EntityRepository, Repository } from "typeorm";
import { SoakStyleEntity } from "../soaks.entity";

@EntityRepository(SoakStyleEntity)
export class SoaksRepository extends Repository<SoakStyleEntity> {

//     async getsoakstyledata(): Promise<any[]> {
//         const query = this.createQueryBuilder('s')
//             .select(`soack_style_id AS soakstyleId , soack_style AS soakstyle ,is_active AS isActive ,created_user AS createdUser, created_at AS createdAt ,
//             updated_at AS updatedAt ,updated_user AS updatedUser ,versionFlag AS version_flag `)
            
//         return await query.getRawMany();
//     }
}